'use strict';

var usedCarsList = function () {
  var defaults = {
    pageSize: 5,
    dom: {
      form: '.js-form-filters',
      kmRange: '.js-range-km',
      priceRange: '.js-range-price',
      makeSelect: '.js-filter-marca',
      modelSelect: '.js-filter-modelo',
      fuelSelect: '.js-filter-combustible',
      ageSelect: '.js-filter-antiguedad',
      kmFromInput: '.js-input-pKmDesde',
      kmToInput: '.js-input-pKmHasta',
      priceFromInput: '.js-input-pPrecioDesde',
      priceToInput: '.js-input-pPrecioHasta',
      submitButton: '.js-button-submit',
      orderSelect: '.js-select-orderby',
      orderInput: '.js-input-orderby',
      pageNumbers: '.js-page-numbers',
      pagePrev: '.js-page-prev',
      pageNext: '.js-page-next',
      currentPage: '.js-input-curPage'
    }
  };

  var params = void 0;

  var _setParams = function _setParams(value) {
    return params = value;
  };
  var _getParams = function _getParams() {
    return params;
  };

  var _setIonRangeSlider = function _setIonRangeSlider(selector, min, max, from, to, postfix) {
    var $elem = $(selector);
    $elem.ionRangeSlider({
      type: 'double',
      min: min,
      max: max,
      from: from,
      to: to,
      postfix: postfix
    });
  };

  var _setPagination = function _setPagination() {
    var p = _getParams();
    var size = p.totalVehicles;
    var fraction = defaults.pageSize;
    var nPages = Math.floor(parseFloat(size / fraction));
    var totalPages = size % fraction > 0 ? nPages + 1 : nPages;
    for (var i = 0; i < totalPages; i++) {
      var nText = '' + (i + 1);
      var $elem = $('<span/>').addClass('vo-page').attr('data-page', i).text(nText);
      if (nText === p.currValue.pageNumber) {
        $elem.addClass('active');
      }
      if (p.currValue.pageNumber === '' + totalPages) {
        $(defaults.dom.pageNext).hide();
      }
      if (p.currValue.pageNumber === '1') {
        $(defaults.dom.pagePrev).hide();
      }
      $(defaults.dom.pageNext).on('click', function () {
        var next = parseInt(p.currValue.pageNumber);
        $(defaults.dom.currentPage).val(next);
        $(defaults.dom.form).submit();
      });
      $(defaults.dom.pagePrev).on('click', function () {
        var prev = parseInt(p.currValue.pageNumber) - 2;
        $(defaults.dom.currentPage).val(prev);
        $(defaults.dom.form).submit();
      });
      $elem.on('click', function () {
        // console.log($(this).data('page'))
        var n = $(this).data('page');
        $(defaults.dom.currentPage).val(n);
        $(defaults.dom.form).submit();
      });
      $(defaults.dom.pageNumbers).append($elem);
    }
  };

  var _setFilters = function _setFilters() {
    var current = _getParams().currValue;
    var data = _getParams().filtersData;
    var $makeSelect = $(defaults.dom.makeSelect),
        $fuelSelect = $(defaults.dom.fuelSelect),
        $ageSelect = $(defaults.dom.ageSelect),
        $modelSelect = $(defaults.dom.modelSelect),
        $orderSelect = $(defaults.dom.orderSelect);

    var arrayMake = [];

    for (var i = 0; i < data.marcamodelo.length; i++) {
      arrayMake.push(data.marcamodelo[i].marca);
      var $item = $('<option />').text(data.marcamodelo[i].marca).attr('value', data.marcamodelo[i].marca);
      $makeSelect.append($item);
    }

    $makeSelect.on('change', function (ev) {
      _setModel($(this).val());
    });

    if (current.make === '') {
      $makeSelect.val('Nissan');
      _setModel('Nissan');
    } else {
      $makeSelect.val(current.make);
      _setModel(current.make);
    }

    if (current.model !== '' && current.make !== 'todos') {
      $modelSelect.val(current.model);
    } else {
      $modelSelect.val('todos');
    }

    for (var _i = 0; _i < data.combustible.length; _i++) {
      var _$item = $('<option />').text(data.combustible[_i]).attr('value', data.combustible[_i]);
      $fuelSelect.append(_$item);
    }

    for (var _i2 = 0; _i2 < data.antiguedad.length; _i2++) {
      var _$item2 = $('<option />').text(data.antiguedad[_i2]).attr('value', data.antiguedad[_i2]);
      $ageSelect.append(_$item2);
    }

    if (current.fuel !== '') {
      $fuelSelect.val(current.fuel);
    }

    if (current.age !== '') {
      $ageSelect.val(current.age);
    }

    if (current.order !== '') {
      $orderSelect.val(current.order);
    }
  };

  var _setModel = function _setModel(make) {
    var data = _getParams().filtersData;

    var $modelSelect = $(defaults.dom.modelSelect);
    $modelSelect.empty();

    var $itemTodo = $('<option />').text('Todos').attr({ 'value': 'todos', 'selected': 'selected' });
    $modelSelect.append($itemTodo);

    if (make !== 'todos') {
      var models = void 0;
      for (var i = 0; i < data.marcamodelo.length; i++) {
        if (data.marcamodelo[i].marca === make) {
          models = data.marcamodelo[i].modelos;
        }
      }
      for (var _i3 = 0; _i3 < models.length; _i3++) {
        var $item = $('<option />').text(models[_i3]).attr('value', models[_i3]);
        $modelSelect.append($item);
      }
    }
  };

  var _setValuesAndSubmit = function _setValuesAndSubmit() {
    var dom = defaults.dom;
    var kmRangeVal = $(dom.kmRange).val();
    $(dom.kmFromInput).val(kmRangeVal.split(';')[0]);
    $(dom.kmToInput).val(kmRangeVal.split(';')[1]);

    var priceRangeVal = $(dom.priceRange).val();
    $(dom.priceFromInput).val(priceRangeVal.split(';')[0]);
    $(dom.priceToInput).val(priceRangeVal.split(';')[1]);

    $(dom.form).submit();
  };

  var _init = function _init(params) {
    var dom = defaults.dom;
    _setParams(params);
    _setIonRangeSlider(dom.kmRange, 0, 500000, params.currValue.kmFrom, params.currValue.kmTo, ' Km');
    _setIonRangeSlider(dom.priceRange, 0, 100000, params.currValue.priceFrom, params.currValue.priceTo, ' €');
    _setPagination();
    _setFilters();
    $(dom.orderSelect).on('change', function () {
      $(dom.orderInput).val($(this).val());
      _setValuesAndSubmit();
    });

    $(dom.submitButton).on('click', function (ev) {
      ev.preventDefault();
      _setValuesAndSubmit();
    });
  };

  return {
    init: _init
  };
}();